import { render, staticRenderFns } from "./ViewOblivionConfirm.vue?vue&type=template&id=1d40a732&"
import script from "./ViewOblivionConfirm.vue?vue&type=script&lang=js&"
export * from "./ViewOblivionConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports